import React, { Component } from 'react';
import { Switch, Route , Link} from 'react-router-dom'



class Footer extends Component {
    shouldComponentUpdate() {
        return false;
    }
    render() {
        return (

                <section className="footer_main">
                    <div className="container">
                        <div className="row footer_main_r1">
                            <div className="col-md-2">
                                <h3>Pages</h3>
                                <ul className="foo_pages">

                                    <li><Link to="/">Home</Link></li>
                                    <li><Link to="/industry-reports">Industry Reports</Link></li>
                                    <li><Link to="/contact-us">Contact Us</Link></li>
                                    <li><Link to="https://blog.mordorintelligence.com/">Blog</Link></li>
                                    <li><Link to="/consulting">Consulting</Link></li>
                                    <li><Link to="/press-release">Press Release</Link></li>

                                </ul>
                            </div>

                            <div className="col-md-2 ">
                                <h3 className="links">Links</h3>
                                <ul className="foo_links">
                                    <li><Link to='/privacy-policy'>Privacy Policy</Link></li>
                                    <li><Link to='/terms-conditions'>Terms and Conditions</Link></li>
                                    <li><Link to="/site-map">Site Map</Link></li>
                                </ul>
                            </div>

                            <div className="col-md-4">
                                <h3 className="links">Join Us</h3>
                                <p className="index-join">
                                    We are always looking to hire talented individuals with equal and extraordinary proportions of industry expertise, problem solving ability and inclination.

                                </p>

                                <p className="index-join">
                                    Interested? please email us<br />
                                    <a href="mailto:careers@mordorintelligence.com" target="_top">careers@mordorintelligence.com</a>
                                </p>
                            </div>

                            <div className="col-md-4">
                                <h3 className="links">Contact</h3>
                                <ul className="contact_ul">
                                    <li>
                                        <span><i className="fa fa-map-marker"></i></span>
                                        <p>5th Floor, Brigade Towers,<br /> Financial District, Gachibowli,<br /> Hyderabad - 500032,<br /> India</p>


                                    </li>
                                    <li>
                                        <span><i className="fa fa-life-ring"></i></span>
                                        <p>+1 617-765-2493</p>
                                    </li>

                                    <li>
                                        <span><i className="fa fa-envelope-o"></i></span>
                                        <p><a href="mailto:info@mordorintelligence.com" target="_top">info@mordorintelligence.com</a></p>
                                    </li>
                                </ul>
                            </div>

                        </div>
                        <div className="row footer_main_r2 text-center">
                            <div className="col-md-12">
                                <img src="https://mordorintelligence.com:81/mordorlabs/img/home_image/logo-gray.jpg" alt="mordor logo gray" id="footer-gry-img" /><br />
                                <span>Mordor Intelligence,<br className="hidden-md hidden-lg hidden-sm" /> Copyright © 2016 . All Rights Reserved.</span>
                            </div>
                        </div>
                    </div>
                </section>


        );
    };
};

export default Footer;



// WEBPACK FOOTER //
// ./src/footer/Footer.js